import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { string, func } from 'prop-types';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { Placeholder } from '@thd-olt-component-react/core-ui';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  Button, Card, CardBody, CardMedia, CardTitle,
} from '@one-thd/sui-atomic-components';
import styles from '../styles/workshops-card.module.scss';

const WorkshopsCardComponent = ({
  name, imageAlt, imagePath, callToActionButtonText, callToActionUrl, description, openRegisterModal
}) => {

  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('workshops-card.ready'); }, []);

  const onWorkshopsCtaClick = (event, { url }) => {
    event.preventDefault();
    window.open(url, '_blank');
  };

  return (
    <Card component="article">
      <CardMedia src={`https://assets.thdstatic.com/images/v1/${imagePath}`} alt={imageAlt} aspect="wide" />
      <CardTitle header={name} />
      <CardBody>
        {description}
      </CardBody>
      <Button
        variant="secondary"
        onClick={
          callToActionButtonText === 'Register'
            ? openRegisterModal
            : (event) => onWorkshopsCtaClick(event, { url: callToActionUrl })
        }
        fullWidth
      >
        {callToActionButtonText}
      </Button>
    </Card>
  );
};

WorkshopsCardComponent.propTypes = {
  name: string.isRequired,
  imageAlt: string.isRequired,
  imagePath: string.isRequired,
  callToActionButtonText: string.isRequired,
  // eslint-disable-next-line react/require-default-props
  callToActionUrl: string,
  description: string.isRequired,
  openRegisterModal: func.isRequired
};

WorkshopsCardComponent.displayName = 'WorkshopsCard';

const HydratedComponent = withHydrator({
  delay: 100,
  id: classNames(styles['workshops-card']),
  placeholder: (
    <Placeholder
      height="450px"
      width="100%"
      type="rect"
    ><div />
    </Placeholder>
  ),
  scrollBuffer: 100
}, WorkshopsCardComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);
/** Generic component for displaying Workshops Cards with CTA buttons */
const WorkshopsCard = DynamicComponent;

export { WorkshopsCard };
